import { render, staticRenderFns } from "./ExchangeFooterApps.vue?vue&type=template&id=950380aa&scoped=true&"
import script from "./ExchangeFooterApps.vue?vue&type=script&lang=js&"
export * from "./ExchangeFooterApps.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeFooterApps.vue?vue&type=style&index=0&id=950380aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950380aa",
  null
  
)

export default component.exports